import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scroll to top on route (pathname) changes, but NOT when only the language
 * segment changes (e.g. /mx/privacy-policy -> /en/privacy-policy).
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Strip leading language segment for comparison
    const stripLang = (p) => {
      const parts = p.split("/").filter(Boolean);
      if (parts[0] === "mx" || parts[0] === "en") parts.shift();
      return "/" + parts.join("/");
    };
    const current = stripLang(pathname);
    const prev = window.__pn_prev_path__;
    if (prev !== current) {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }
    window.__pn_prev_path__ = current;
  }, [pathname]);

  return null;
}
